import TermsAndConditionsFormContainer from './TermsAndConditionsFormContainer';
export default TermsAndConditionsFormContainer;
